/*Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.*/
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable, catchError, filter, finalize, switchMap, take, throwError } from 'rxjs';
import { SessionmanagementService } from './sessionmanagement.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class AppInterceptorService implements HttpInterceptor {
  constructor(
    private readonly sessionService: SessionmanagementService,
    private readonly storageService: StorageService
  ) {}


  isRefreshing = false;
  private mockResponse:any;
  refreshTokenSubject: BehaviorSubject<string | null> =
    new BehaviorSubject<string | null>(null);

  handleExpiredToken(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<any> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;

      // Notify all waiting requests that the token is being refreshed
      this.refreshTokenSubject.next(null);

      return this.sessionService.refreshToken().pipe(
        switchMap((newToken: any) => {
          this.isRefreshing = false;
          let token = this.storageService.getStorageItem('access_token');
          this.refreshTokenSubject.next(token);
          return next.handle(this.addAuthToken(req, token));
        }),
        catchError((error) => {
          this.isRefreshing = false;
          this.sessionService.openTimeout(); // Log out on error
          return EMPTY;
        }),
        finalize(() => {
          this.isRefreshing = false; // Reset the flag
        })
      );
    } else {
      // Queue requests while a token is being refreshed
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((token) => next.handle(this.addAuthToken(req, token)))
      );
    }
  }


  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // this.mockResponse = this.storageService.getStorageItem("mockresponse");

    // const useMock = environment.useMockApi || !navigator.onLine;

    // if (useMock && !req.url.endsWith('assets/json/menu.json') && !req.url.endsWith('assets/json/mockResponse.json')) {     
    //   const mockData = this.getMockData(req);
    //   return of(new HttpResponse({ status: 200, body: mockData }));
    // }
    
    if (req.url.endsWith('/refresh') || !this.sessionService.isLoggedIn()) {
      if (req.url.endsWith('/refresh')) {
        let refresh_token = this.storageService.getStorageItem('refresh_token');
        if (refresh_token) {
          req = this.addAuthToken(req, refresh_token);
        }
      }
      if (req.url.endsWith('/change-password')) {
        let tempToken = this.storageService.getStorageItem('tempLoginToken', false);
        if (tempToken) {
          req = this.addAuthToken(req, tempToken);
        }
      }
      return next.handle(req);
    } else {
      let token = this.storageService.getStorageItem('access_token');
      if (token) {
        req = this.addAuthToken(req, token);
      }

      return next.handle(req).pipe(
        catchError((error, caught) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status && error.status === 401) {
              return this.handleExpiredToken(req, next);
            }
            return throwError(() => error);
          }
          return throwError(() => error);
        })
      );
    }
  }

  private addAuthToken(req: HttpRequest<any>, token: string | null) {
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
    return req;
  }

  getMockData(req: HttpRequest<any>){
    let urlToFetch = req.url.split('/api/');
    if(this.mockResponse){
      return JSON.parse(this.mockResponse)[urlToFetch[1]]
    }
  }
  updateHeader(req: HttpRequest<any>) {
    const authToken = this.storageService.getStorageItem('access_token');
    req = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${authToken}`),
    });
    return req;
  }
}
